<template>
  <div>
    <b-modal v-model="isOpen" centered hideFooter hideHeader @pause="updatePaused">
      <div class="m-body">
        <video id="videoElement" autoplay controls @canplay="updatePaused" @playing="updatePaused" @pause="updatePaused" v-if="profileVideoUrl" media="all and (max-width:500px)">
          <source :src="profileVideoUrl" type="video/mp4">
          <track label="English" kind="subtitles" srclang="en">
        </video>

        <iframe v-else-if="youtubeUrl" width="294" height="300" :src="youtubeVideo" title="" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" ></iframe>
        <div v-else-if="userAvatar" class="avatar-modal">
          <img :src="userAvatar" />
        </div>
        <p v-else class="null">Sorry this user hasn't updated video yet</p>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { AUTOPLAY_YOUTUBE_VIMEO } from '@/utils/constants'
import Common from '@/mixins/Common'
export default {
  name: 'VideoModal',
  data () {
    return {
      isOpen: false,
      talentProfile: {},
      videoElement: null,
      paused: null,
      youtubeVideo: '',
      isPlayYoutubevideo: false,
      profileVideoUrl: '',
      youtubeUrl: '',
      userAvatar: ''
    }
  },
  mixins: [Common],
  computed: {
    playing() { return !this.paused }
  },
  watch: {
    youtubeUrl: {
      handler: async function () {
        this.youtubeVideo = this.setVideoYoutube(this.youtubeUrl) + AUTOPLAY_YOUTUBE_VIMEO
        if (this.youtubeUrl) {
          this.isPlayYoutubevideo = true
        } else {
          this.isPlayYoutubevideo = false
        }
      }
    }
  },
  methods: {
    showModal () {
      this.isOpen = true
    },
    hideModal () {
      this.isOpen = false
      this.pause()
    },
    updatePaused(event) {
      this.videoElement = event.target
      this.paused = event.target.paused
    },
    play() {
      this.videoElement.play()
    },
    pause() {
      this.videoElement.pause()
      this.videoElement.currentTime = 0
    },
    setProfileVideoUrl: async function (userProfile) {
      if (userProfile.hasOwnProperty('logo_url')) {
        if (userProfile.video_url) {
          this.profileVideoUrl = userProfile.video_url
          this.youtubeUrl = ''
          this.userAvatar = ''
        } else if (userProfile.youtube_url) {
          this.profileVideoUrl = ''
          this.userAvatar = ''
          this.youtubeUrl = userProfile.youtube_url
        } else {
          this.profileVideoUrl = ''
          this.youtubeUrl = ''
          this.userAvatar = userProfile.logo_url
        }
      } else {
        if (userProfile.profile_video_url) {
          this.profileVideoUrl = userProfile.profile_video_url
          this.youtubeUrl = ''
          this.userAvatar = ''
        } else if (userProfile.youtube_url) {
          this.profileVideoUrl = ''
          this.userAvatar = ''
          this.youtubeUrl = userProfile.youtube_url
        } else {
          this.profileVideoUrl = ''
          this.youtubeUrl = ''
          this.userAvatar = userProfile.avatar_url
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  font-size: 20px;
}
.m-body {
  overflow-y: auto;
  width: 100%;
  min-height: 300px;
}
#videoElement {
    width: 100%;
}
.null{
    font-size: 20px;
    text-align: center;
    text-transform: uppercase;
    opacity: 0.35;
    font-weight: 600;
    position: absolute;
    left: 0;
    right: 0;
    top: 40%;
}
iframe{
    width: 100%;
    margin-top: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoModal.vue